
<ng-container *ngIf="brandLogoVisibility">
  <brand-logo-pulse [size]="width"></brand-logo-pulse>
</ng-container>

<div [id]="'welcome-view-header-' + textTypedId" class="welcome-view--header" [textTyped]="textTypedId"></div>
